import { render, staticRenderFns } from "./InputEmail.vue?vue&type=template&id=f12a01ee&"
import script from "./InputEmail.vue?vue&type=script&lang=js&"
export * from "./InputEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports